import { LinkDropdown } from '@zipdrug/ui';
import { StyleSheet } from 'aphrodite/no-important';
import { get } from 'lodash';
import { CallCenterContext } from 'contexts/CallCenterContextProvider';
import PropTypes from 'prop-types';
import React, { useContext, useState, useCallback } from 'react';
import PatientInfoDropdownButton from '../PatientInfoDropdownButton';
import PharmacyMenu from './PharmacyMenu';
import PharmacyFormContainer from './PharmacyFormContainer';

const sx = StyleSheet.create({
  menuStyles: {
    left: '50%',
    right: 'initial',
    transform: 'translateX(-50%)',
  },
  title: {
    maxWidth: '25rem',
  },
});

const PharmacyDropdown = ({ patient, refetchSelectedPatientInfo }) => {
  const { setPharmacyReassigned } = useContext(CallCenterContext);
  const [isEditing, setIsEditing] = useState(false);

  const onEdit = useCallback(
    (_, forceResetEditState) => {
      if (isEditing && refetchSelectedPatientInfo) refetchSelectedPatientInfo();
      setIsEditing(editing => (forceResetEditState ? false : !editing));
    },
    [isEditing, refetchSelectedPatientInfo],
  );

  const onReAssignPharmacy = useCallback(() => {
    if (refetchSelectedPatientInfo) refetchSelectedPatientInfo();
  }, [refetchSelectedPatientInfo]);

  const onToggleDropdown = useCallback(
    isOpen => {
      if (!isOpen) {
        onEdit(null, true);
      }
    },
    [onEdit],
  );

  if (!patient) return null;

  const menu = isEditing ? (
    <PharmacyFormContainer
      onToggleEdit={onEdit}
      onReAssignPharmacy={assigned_pharmacy_id => {
        setPharmacyReassigned(assigned_pharmacy_id);
        onReAssignPharmacy();
      }}
    />
  ) : (
    <PharmacyMenu onToggleEdit={onEdit} pharmacy={get(patient, 'assigned_pharmacy')} />
  );

  return (
    <LinkDropdown
      buttonRenderer={
        <PatientInfoDropdownButton
          id="e2e-pharmacyDropdownNameDropdown"
          icon="storefront"
          text={get(patient, 'assigned_pharmacy.name', 'Pharmacy unavailable')}
          title="View patient's preferred pharmacy"
        />
      }
      menuRenderer={menu}
      menuStyles={sx.menuStyles}
      onToggle={onToggleDropdown}
    />
  );
};

PharmacyDropdown.propTypes = {
  isEditing: PropTypes.bool, // kept for backward compatibility
  onEdit: PropTypes.func, // kept for backward compatibility
  onReAssignPharmacy: PropTypes.func, // kept for backward compatibility
  onToggleDropdown: PropTypes.func, // kept for backward compatibility
  patient: PropTypes.object,
  refetchSelectedPatientInfo: PropTypes.func,
};

export default PharmacyDropdown;
